export default __webpack_public_path__ + "static/media/GPA_PowerRestorationAdvisory_background.e6ba4a57.png";